import React from "react";
import { ErrorBoundary } from "@sscs/ui";
import Behaviour from "./Behaviour";
const BehaviorTabContent = () => {
    return (React.createElement(React.Fragment, null,
        React.createElement(ErrorBoundary, { key: "behavior" },
            React.createElement(Behaviour, null))));
};
export default BehaviorTabContent;
//# sourceMappingURL=BehaviorTabContent.js.map